module.exports = __webpack_public_path__ + "img/LC_ASI_GameIcon_Rou_JA_JP.jpg";